import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { v4 as uuid } from 'uuid';

import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../../components/common/WhitePad/WhitePad';
import SecondaryNavigation from '../../../../../components/common/navigation/SecondaryNavigation';
import TitleComponent from '../../../../../components/common/forms/Title/TitleComponent';

import InventoryApi from '../../../../../services/api/InventoryApi';

import ReserveProductBlock from './components/ReserveProductBlock';
import { ProductX } from '~/src/types/Misc';

interface ParamProps {
  id: string;
  consolidation?: any;
}

export default function OrderReserve(): JSX.Element {
  const history = useHistory();
  const { consolidation, id } = useParams<ParamProps>();
  const [itemData, setItemData] = useState<ProductX[] | null>(null);
  const getItem = async (): Promise<void> => {
    const result = await InventoryApi.getAvailableForReservation(id);
    if (result.status === StatusCodes.OK) {
      setItemData(result.data);
    }
  };

  useEffect(() => {
    getItem();
  }, []);

  return (
    <WhitePad isFluid>
      <SecondaryNavigation isConsolidation={consolidation} />
      <TitleComponent
        title="Reserve Units"
        onLeftHandler={(): void => {
          history.push('/orders-list');
        }}
      />
      {itemData?.map((item, index) => {
        return <ReserveProductBlock item={item} key={uuid()} id={id} index={index + 1} />;
      })}
    </WhitePad>
  );
}
